import withRangoProfesionalDocente from '../../hoc/Docentes/withRangoProfesionalDocente';
import RangoProfesionalSeleccionados from '../../view/components/RegistroUsuarios/Clasificacion/EditarClasificacion/RangoProfesionalSeleccionados';

export default withRangoProfesionalDocente(RangoProfesionalSeleccionados);